import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { ClassNameOnlyProps } from 'components/ozone-component';

interface IframelyProps extends ClassNameOnlyProps {
  html: string;
}

export const Container = styled.div`
  overflow: auto;
  > div {
    padding-bottom: 0 !important;
  }
`;

export const Iframely: FC<IframelyProps> = ({ html, className }) => {
  useEffect(() => {
    if (html) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.iframely) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.iframely.load();
      }
    }
  }, [html]);

  return (
    <Container
      className={className}
      // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
